/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{ "rawString": ".root_71c51772{position:relative;padding:10px 84px;cursor:pointer}.root_71c51772 .ms-Link{font-size:12px}\n" }]);
export var root = "root_71c51772";
//# sourceMappingURL=GroupShowAll.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib-es2015/components/GroupedList/GroupShowAll.scss.js
// module id = 763
// module chunks = 0